<template>
    <v-card elevation="3" outlined class="card-metrica" :class="`faixa-${faixa}`">
        <div class="d-flex align-center">
            <v-avatar tile rounded size="42" :color="cor" class="br-5 mr-3">
                <v-icon color="white">{{ icone }}</v-icon>
            </v-avatar>

            <div class="flex-grow-1 minimo">
                <div class="rotulo">{{ label }}</div>
                <div class="valor">{{ valor }}</div>
                <div v-if="sub" class="sub text--secondary">{{ sub }}</div>
            </div>
        </div>

        <v-progress-linear
            v-if="progresso !== null"
            class="mt-2"
            height="6"
            rounded
            :value="progresso"
            :color="cor"
        />
    </v-card>
</template>

<script>
export default {
    name: 'CardMetrica',

    props: {
        label: { type: String, default: '' },
        valor: { type: [String, Number], default: '' },
        sub: { type: String, default: '' },
        icone: { type: String, default: 'mdi-gauge' },
        // Vem da avaliação contra as regras de alerta — o card fica vermelho pelo
        // mesmo critério que dispara o e-mail, não por um número solto no front.
        faixa: { type: String, default: 'ok' },
        progresso: { type: Number, default: null },
    },

    computed: {
        cor() {
            if (this.faixa === 'critico') return 'red darken-1';
            if (this.faixa === 'aviso') return 'amber darken-2';
            return 'blue-grey darken-1';
        },
    },
};
</script>

<style scoped>
.card-metrica {
    padding: 12px;
    height: 100%;
}

.card-metrica.faixa-aviso {
    border-color: #ff8f00 !important;
}

.card-metrica.faixa-critico {
    border-color: #c62828 !important;
}

.minimo {
    min-width: 0;
}

.rotulo {
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    opacity: 0.7;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.valor {
    font-size: 22px;
    font-weight: 600;
    line-height: 1.2;
}

.sub {
    font-size: 11px;
}

.br-5 {
    border-radius: 5px !important;
}
</style>
